module.exports = __webpack_public_path__ + "static/media/banner5.b7fb318a.jpg";